<template>
  <div class="body">
    <div class="title">
      <div style="width:22%;float: left">
        <img style="width:100%;height: 85px;" src="../../../../public/img/stepIcon.png" alt="">
      </div>
      <div
          style="width:40%;height:88px;float: left;padding-top:10px;font-size:30px;font-weight:700;border-left:2px solid #333;border-right:2px solid #333;text-align:center;line-height: 60px">
        <div>出厂检验报告</div>
      </div>
      <div style="width: max-content; float: left">
        <div style="width: 100%; padding: 5px; height:88px; display: flex; flex-direction: column; justify-content: space-between">
          <div>
            版本Ver: C
            <span style="float: right; margin-right: 15px">
              修订Rev: 0
            </span>
          </div>
          <div>编号Num: STEP/ R-DJ-QD-015-04</div>
          <div>NO.</div>
        </div>
      </div>
    </div>
    <div class="table">
      <table>
        <tr>
          <td style="width: 42%">批次号Batch NO：{{inspectionRecord.cableCode}}/{{inspectionRecord.clientContractNo}}</td>
          <td colspan="2">数量：{{inspectionRecord.impactNum===0? 1:inspectionRecord.impactNum}} PCS</td>
        </tr>
        <tr>
          <td style="width: 42%">物料号 Material Number：{{inspectionRecord.partNo}}</td>
          <td v-if="inspectionRecord.procurementInspection.includes('韩国蒂升主板')" colspan="2">物料描述 Material Desc：MC2-BE主控板</td>
          <td v-else colspan="2">物料描述 Material Desc：{{inspectionRecord.procurementInspection}}</td>
        </tr>
        <tr>
          <td>检验日期 Inspection Date：{{inspectionRecord.scanDate}}</td>
          <td colspan="2">产品编号Product No：{{inspectionRecord.cabinetCode}}</td>
        </tr>
        <tr>
          <td>
            设备检定周期 Equipment Verification Period
            <div style="margin-top: 10px">
              <span v-if="inspectionRecord.verificationPeriodResult">☑</span>
              <el-checkbox v-else/>
              有效 Effective
              <span style="float: right; margin-right: 15px">
                <span v-if="inspectionRecord.verificationPeriodResult === false">☑</span>
                <el-checkbox v-else/>
                <span style="margin-left: 5px">无效 Invalid</span>
              </span>
            </div>
          </td>
          <td>
            静电防护 ESD
            <div style="margin-top: 10px">
              <span v-if="inspectionRecord.esdResult">☑</span>
              <el-checkbox v-else/>
              合格 Qualified
              <span style="float: right; margin-right: 15px">
                <span v-if="inspectionRecord.esdResult === false">☑</span>
                <el-checkbox v-else/>
                <span style="margin-left: 5px">不合格 Unqualified</span>
              </span>
            </div>
          </td>
          <td>
            5S
            <div style="margin-top: 10px">
              <span v-if="inspectionRecord.firstCheckResult">☑</span>
              <el-checkbox v-else/>
              合格 Qualified
              <span style="float: right; margin-right: 15px">
                <span v-if="inspectionRecord.firstCheckResult === false">☑</span>
                <el-checkbox v-else/>
                <span style="margin-left: 5px">不合格 Unqualified</span>
              </span>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <table :class="inspectionRecord.inspectionType === 10 ? 'process2' : 'process'">
      <tr style="font-weight: 600">
        <td>工序 Processes</td>
        <td>检验内容 Inspect Content</td>
        <td>检验结果 Inspect Result</td>
        <td>备注 Notes</td>
      </tr>
      <tr v-for="(item, index) in inspectionRecord.itemDetails" :key="index">
        <td class="processTitle">{{item.itemName}}</td>
        <td class="content">{{item.inspectionRequirement}}</td>
        <td class="result">
          <span v-if="item.inspectionResult === '1'">√</span>
          <span v-if="item.inspectionResult === '0'">×</span>
        </td>
        <td class="note">{{item.note}}</td>
      </tr>
    </table>
    <div class="partA">
      <img v-if="checkImg(inspectionRecord)" class="img" src="../../../../public/img/qualityInspection.png" alt="">
      <div style="height:40px">
        <h4>检验结论：</h4>
        <h4 style="margin-left:20%">
          合格：
          <span v-if="inspectionRecord.firstArticleResult">☑</span>
          <el-checkbox v-else/>
        </h4>
        <h4>
          不合格：
          <span v-if="inspectionRecord.firstArticleResult === false">☑</span>
          <el-checkbox v-else/>
        </h4>
      </div>
      <h4>检验员签字 Inspector：{{inspectionRecord.scanMenName}}</h4>
    </div>
    <div class="footTable">
      <div>填表说明：每工序检验合格的，在检验结果栏内打“√”，不合格的打“╳”，并作不合格描述。</div>
      <div>Form filling explanation: Inspection of each process conformity fill “√”,inconformity fill “╳”, and fill unqualified description.</div>
    </div>
    <div class="footer">
      <div>
        <span>适用公司：电机（DJ）</span>
        <span style="float: right;">保存期限： 10年</span>
      </div>
      <div>
        <span>Range: DQ</span>
        <span style="float: right;">Preservation: 10 Years</span>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "KZGInspectionPrintContent",
    props: {
      inspectionRecord: {
        type: Object,
        required: true,
      },
    },
    methods: {
      checkImg(row) {
        console.log(row);
        if (!row.itemDetails || row.itemDetails.some(item => item.inspectionResult !== "1")) {
          return false;
        }
        return row.firstCheckResult && row.verificationPeriodResult && row.esdResult && row.firstArticleResult;
      },
    },
  };
</script>
<style lang="scss">
.body {
  position: relative;
  font-size: 12px;

  .title {
    width: 98%;
    height: 100px;
    border: 2px solid #333;
    box-sizing: border-box;
  }

  .table {
    //margin-top: 20px;
    width: 100%;
  }

  .process {
    width: 98%;
    border-collapse: collapse;
    .processTitle {
      width: 20%;
      white-space: pre-wrap;
    }
    .content {
      white-space: pre-wrap;
      line-height: 20px;
      word-wrap: break-word;
      word-break: break-all;
    }
    .result {
      width: 16%;
      text-align: center;
    }
    .note {
      width: 20%;
      word-break: break-all;
      word-wrap: break-word;
    }
  }

  .process2 {
    width: 98%;
    border-collapse: collapse;
    .processTitle {
      width: 20%;
      white-space: pre-wrap;
    }
    .content {
      white-space: pre-wrap;
      line-height: 18px;
      word-wrap: break-word;
      word-break: break-all;
    }
    .result {
      width: 16%;
      text-align: center;
    }
    .note {
      width: 12%;
      word-break: break-all;
      word-wrap: break-word;
    }
  }

  .process td {
    border: 1px solid #333;
    padding: 5px 10px;
    border-top: none;
  }

  .process2 td {
    border: 1px solid #333;
    padding: 5px 10px;
    border-top: none;
  }

  .table table {
    width: 98%;
    border-collapse: collapse;
  }

  .table tr {
    width: 100%;
  }

  .table td {
    font-weight: 600;
    border: 1px solid #333;
    padding: 10px;
  }

  h4 {
    float: left;
    margin: 2px;
  }

  .partA {
    width: 98%;
    height: 100px;
    border: 1px solid #333;
    border-top: none;
    box-sizing: border-box;
    page-break-inside: avoid;

    img {
      height: 200px;
      width: 200px;
      position: absolute;
      top: 60%;
      right: 7%;
      page-break-inside: avoid;
    }
  }

  .partA h4 {
    padding: 5px;
  }

  .input .el-textarea__inner {
    height: 10vh;
    width: 98%;
  }

  .footTable {
    width: 98%;
    border: 1px solid #333;
    border-top: none;
    box-sizing: border-box;
  }

  .footTable div {
    padding: 3px;
  }

  .footer {
    margin-top: 5px;
    width: 98%;
    height: 40px;
    padding: 0 40px 5px 5px;
    border: 1px solid #333;
    box-sizing: border-box;
    page-break-after: always;
  }
}
</style>
